import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b170e60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dropdown-menu" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-popper__arrow",
  style: {"left":"10px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "el-zoom-in-center" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        "aria-hidden": "true",
        class: "el-dropdown__popper el-popper is-light is-pure custom-contextmenu",
        role: "tooltip",
        "data-popper-placement": "bottom",
        style: _normalizeStyle(`top: ${_ctx.dropdowns.y + 5}px;left: ${_ctx.dropdowns.x}px;`),
        key: Math.random()
      }, [
        _createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropdownList, (v, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (!v.affix)
                ? (_openBlock(), _createElementBlock("li", {
                    class: "el-dropdown-menu__item",
                    "aria-disabled": "false",
                    tabindex: "-1",
                    key: k,
                    onClick: ($event: any) => (_ctx.onCurrentContextmenuClick(v.contextMenuClickId))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(v.icon)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(v.txt)), 1)
                  ], 8, _hoisted_2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _hoisted_3
      ], 4)), [
        [_vShow, _ctx.isShow]
      ])
    ]),
    _: 1
  }))
}